function listgridJavascript() {
  Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(link => {
      link.addEventListener('click', function(event) {
          Array.from(document.querySelectorAll(".wblistgridbtn")).forEach(e => e.classList.remove('active'));
          this.classList.add('active');
          if(this.classList.contains('listv')){
              document.getElementById('product-grid').classList.add('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-twogrid');
              // Remove 'active' class from gridv on mobile
                if (window.innerWidth < 992) { 
                  document.querySelector(".gridv").classList.remove('active_mobile'); 
                }  
          }else if(this.classList.contains('gridv')){  
              document.getElementById('product-grid').classList.add('product-grid');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-twogrid');
          }else if(this.classList.contains('galleryv')){
              document.getElementById('product-grid').classList.add('product-gallery');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
              document.getElementById('product-grid').classList.remove('product-twogrid');
          }else if(this.classList.contains('twogrid')){
              document.getElementById('product-grid').classList.add('product-twogrid');
              document.getElementById('product-grid').classList.remove('product-gallery');
              document.getElementById('product-grid').classList.remove('product-list');
              document.getElementById('product-grid').classList.remove('product-grid');
          }
          // Persist view choice in localStorage across pages
          try { localStorage.setItem('wbGridView', this.className.replace('wblistgridbtn ','').trim().split(' ')[0]); } catch(e){}
      });
  });
  // Restore persisted view choice on page load
  try {
    var saved = localStorage.getItem('wbGridView');
    var grid = document.getElementById('product-grid');
    if (saved && grid) {
      var btn = document.querySelector('.wblistgridbtn.' + saved);
      if (btn) btn.click();
    }
  } catch(e){}
};
document.addEventListener("shopify:section:load", listgridJavascript);
listgridJavascript();

// ─── VIDEO SCROLL — throttled via requestAnimationFrame to fix Forced Reflow ───
// Using rAF prevents layout thrashing from getBoundingClientRect on every scroll event
var _videoScrollTicking = false;
window.addEventListener('load', videoScroll);
window.addEventListener('scroll', function() {
  if (!_videoScrollTicking) {
    window.requestAnimationFrame(function() {
      videoScroll();
      _videoScrollTicking = false;
    });
    _videoScrollTicking = true;
  }
}, { passive: true }); // passive:true tells browser scroll is not blocked → better scroll perf

function videoScroll() {
  var videos = document.querySelectorAll('video[autoplay]');
  if (videos.length === 0) return; // bail early if no autoplay videos on page
  var windowHeight = window.innerHeight;
  for (var i = 0; i < videos.length; i++) {
    var thisVideoEl = videos[i],
        videoHeight = thisVideoEl.clientHeight,
        videoClientRect = thisVideoEl.getBoundingClientRect().top;
    if ( videoClientRect <= ( (windowHeight) - (videoHeight*.5) ) && videoClientRect >= ( 0 - ( videoHeight*.5 ) ) ) {
      thisVideoEl.play();
    } else {
      thisVideoEl.pause();
    }
  }
}

// ─── COUNTDOWN TIMER — guarded: only runs if .countd_all elements exist ───
// Fixes: setInterval running on every page even with no countdown widget
(function() {
  function startCountdown() {
    countDown(); // run once immediately so numbers show instantly
    setInterval(countDown, 1000);
  }

  if (document.querySelector('.countd_all')) {
    startCountdown();
  } else {
    // Also watch for theme editor section loads
    document.addEventListener('shopify:section:load', function() {
      if (document.querySelector('.countd_all') && !window._wbCountdownStarted) {
        window._wbCountdownStarted = true;
        startCountdown();
      }
    });
  }
})();

function countDown() {
  const countCardSections = document.querySelectorAll('.countd_all');
  countCardSections.forEach((countdownSection) => {
    var countDownDate = new Date(countdownSection.getAttribute('data-date')).getTime();
    var now = new Date().getTime();
    var distance = countDownDate - now;
    if (distance < 0 || isNaN(countDownDate)) {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = "00";
      countdownSection.querySelector('.main_chours .wb_chours').textContent = "00";
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = "00";
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = "00";
    }
    else {
      countdownSection.querySelector('.main_cdays .wb_cdays').textContent = Math.floor(distance / (1000 * 60 * 60 * 24));
      countdownSection.querySelector('.main_chours .wb_chours').textContent = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      countdownSection.querySelector('.main_cminutes .wb_cminutes').textContent = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      countdownSection.querySelector('.main_cseconds .wb_cseconds').textContent = Math.floor((distance % (1000 * 60)) / 1000);
    }
  });
}